import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import ScenarioSelectionDetailedSummaryLayout from './ScenarioSelectionDetailedSummaryLayout';
import ScenarioSelectionDetailedSummaryMetaOverride from './ScenarioSelectionDetailedSummaryMetaOverride';
import { useScenarioDetailTableContext } from './ScenarioDetailTableContext';

const ScenarioSelectionDetailedSummary = () => {
  const {
    loading,
    loadingError,
    scenarioDetailsCollection,
  } = useScenarioDetailTableContext();

  return (
    <DataContainer
      component={MetaCollectionRenderer}
      componentProps={{
        collection: scenarioDetailsCollection,
        layout: ScenarioSelectionDetailedSummaryLayout,
        metaOverrideSet: ScenarioSelectionDetailedSummaryMetaOverride,
      }}
      loading={loading && !scenarioDetailsCollection}
      loadingError={loadingError}
    />
  );
};

ScenarioSelectionDetailedSummary.propTypes = {
};
ScenarioSelectionDetailedSummary.defaultProps = {};

export default ScenarioSelectionDetailedSummary;
